import React, { useEffect, useState } from 'react';
import { Menu, X, Download } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Features',
    href: '#features'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="flex items-center justify-between" data-id="element-198">
          {/* Logo */}
          <a href="#" className="flex items-center space-x-2 group" data-id="element-199">
            <img src="https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp" alt="IntelliEats icon" className="h-10 w-10 rounded-xl shadow-lg group-hover:shadow-brand-200/50 transition-all duration-300" data-id="element-200" />
            <span className="text-xl font-bold text-slate-900 tracking-tight" data-id="element-201">
              Intelli<span className="text-brand-600" data-id="element-202">Eats</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-203">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-600 transition-colors" data-id="element-204">
                {link.name}
              </a>)}
            <a href="#download" className="inline-flex items-center px-5 py-2.5 text-sm font-semibold text-white bg-brand-600 rounded-full hover:bg-brand-700 transition-colors shadow-lg shadow-brand-200/50 hover:shadow-brand-300/50 transform hover:-translate-y-0.5 duration-200" data-id="element-205">
              <Download className="w-4 h-4 mr-2" data-id="element-206" />
              Download Free
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-207">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-slate-600 hover:text-brand-600 transition-colors" aria-label="Toggle menu" data-id="element-208">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-209" /> : <Menu className="h-6 w-6" data-id="element-210" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-211">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100 overflow-hidden" data-id="element-212">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-213">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-600 hover:text-brand-600 hover:bg-brand-50 rounded-lg transition-colors" data-id="element-214">
                  {link.name}
                </a>)}
              <div className="pt-4" data-id="element-215">
                <a href="#download" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center w-full px-5 py-3 text-base font-semibold text-white bg-brand-600 rounded-xl hover:bg-brand-700 transition-colors shadow-lg" data-id="element-216">
                  <Download className="w-5 h-5 mr-2" data-id="element-217" />
                  Download Free
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}